import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98cd9a1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-column flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_7 = {
  key: 1,
  class: "d-flex align-items-center text-gray-400 me-5 mb-2"
}
const _hoisted_8 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_11 = { class: "card mb-5 mb-xl-10" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "card-title m-0" }
const _hoisted_14 = { class: "fw-boldest m-0" }
const _hoisted_15 = { class: "card-body p-9" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group d-flex flex-wrap" }
const _hoisted_19 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group d-flex flex-wrap" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Status", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Activated")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Pending")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Offline")
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "form-group d-flex flex-wrap" }
const _hoisted_29 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "form-group d-flex flex-wrap" }
const _hoisted_32 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "form-group d-flex flex-wrap" }
const _hoisted_36 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Launched")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Trial")
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1))
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "form-group d-flex flex-wrap" }
const _hoisted_43 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "form-group d-flex flex-wrap" }
const _hoisted_46 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-md-6" }
const _hoisted_49 = { class: "form-group d-flex flex-wrap" }
const _hoisted_50 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = { class: "form-group d-flex flex-wrap" }
const _hoisted_53 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-md-6" }
const _hoisted_56 = { class: "form-group d-flex flex-wrap" }
const _hoisted_57 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-md-6" }
const _hoisted_60 = { class: "form-group d-flex flex-wrap" }
const _hoisted_61 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_62 = { class: "col-md-6" }
const _hoisted_63 = { class: "form-group d-flex flex-wrap" }
const _hoisted_64 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "col-md-6" }
const _hoisted_67 = { class: "form-group d-flex flex-wrap" }
const _hoisted_68 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_69 = { class: "col-md-6" }
const _hoisted_70 = { class: "form-group d-flex flex-wrap" }
const _hoisted_71 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "col-md-6" }
const _hoisted_74 = { class: "form-group d-flex flex-wrap" }
const _hoisted_75 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_76 = { class: "col-md-6" }
const _hoisted_77 = { class: "form-group d-flex flex-wrap" }
const _hoisted_78 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col-md-6" }
const _hoisted_81 = { class: "form-group d-flex flex-wrap" }
const _hoisted_82 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_83 = { class: "col-md-6" }
const _hoisted_84 = { class: "form-group d-flex flex-wrap" }
const _hoisted_85 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_86 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_87 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_88 = { class: "indicator-label" }
const _hoisted_89 = { class: "card mb-5 mb-xl-10" }
const _hoisted_90 = { class: "card-header" }
const _hoisted_91 = { class: "card-title m-0" }
const _hoisted_92 = { class: "fw-boldest m-0" }
const _hoisted_93 = { class: "card-body p-9" }
const _hoisted_94 = { class: "row" }
const _hoisted_95 = { class: "col-md-6" }
const _hoisted_96 = { class: "form-group d-flex flex-wrap" }
const _hoisted_97 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_98 = { class: "col-md-6" }
const _hoisted_99 = { class: "form-group d-flex flex-wrap" }
const _hoisted_100 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_101 = { class: "row mb-3" }
const _hoisted_102 = { class: "col-md-12" }
const _hoisted_103 = { class: "form-group d-flex flex-wrap" }
const _hoisted_104 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_105 = { class: "d-flex flex-row align-items-center mb-5" }
const _hoisted_106 = { class: "mb-0" }
const _hoisted_107 = { class: "svg-icon svg-icon-2" }
const _hoisted_108 = { class: "mb-10" }
const _hoisted_109 = ["onClick"]
const _hoisted_110 = { class: "svg-icon svg-icon-3" }
const _hoisted_111 = ["onClick"]
const _hoisted_112 = { class: "svg-icon svg-icon-3" }
const _hoisted_113 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_114 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_115 = { class: "indicator-label" }
const _hoisted_116 = { class: "card mb-5 mb-xl-10" }
const _hoisted_117 = { class: "card-header" }
const _hoisted_118 = { class: "card-title m-0" }
const _hoisted_119 = { class: "fw-boldest m-0" }
const _hoisted_120 = { class: "card-body p-9" }
const _hoisted_121 = { class: "d-flex flex-row align-items-center mb-5" }
const _hoisted_122 = { class: "mb-0" }
const _hoisted_123 = { class: "svg-icon svg-icon-2" }
const _hoisted_124 = /*#__PURE__*/_createTextVNode(" Add Parent Merchant Relationship ")
const _hoisted_125 = { class: "mb-10" }
const _hoisted_126 = ["onClick"]
const _hoisted_127 = { class: "svg-icon svg-icon-3" }
const _hoisted_128 = ["onClick"]
const _hoisted_129 = { class: "svg-icon svg-icon-3" }
const _hoisted_130 = { class: "d-flex flex-row align-items-center mb-5" }
const _hoisted_131 = { class: "mb-0" }
const _hoisted_132 = { class: "svg-icon svg-icon-2" }
const _hoisted_133 = /*#__PURE__*/_createTextVNode(" Add Related Merchant Relationship ")
const _hoisted_134 = { class: "mb-10" }
const _hoisted_135 = ["onClick"]
const _hoisted_136 = { class: "svg-icon svg-icon-3" }
const _hoisted_137 = ["onClick"]
const _hoisted_138 = { class: "svg-icon svg-icon-3" }
const _hoisted_139 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_140 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_141 = { class: "indicator-label" }
const _hoisted_142 = { class: "card mb-5 mb-xl-10" }
const _hoisted_143 = { class: "card-header" }
const _hoisted_144 = { class: "card-title m-0" }
const _hoisted_145 = { class: "fw-boldest m-0" }
const _hoisted_146 = { class: "card-body p-9" }
const _hoisted_147 = { class: "row" }
const _hoisted_148 = { class: "col-md-6" }
const _hoisted_149 = { class: "form-group d-flex flex-wrap" }
const _hoisted_150 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_151 = { class: "col-md-6" }
const _hoisted_152 = { class: "form-group d-flex flex-wrap" }
const _hoisted_153 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_154 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_155 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_156 = { class: "indicator-label" }
const _hoisted_157 = { class: "card mb-5 mb-xl-10" }
const _hoisted_158 = { class: "card-header" }
const _hoisted_159 = { class: "card-title m-0" }
const _hoisted_160 = { class: "fw-boldest m-0" }
const _hoisted_161 = { class: "card-body p-9" }
const _hoisted_162 = { class: "row" }
const _hoisted_163 = { class: "col-md-6" }
const _hoisted_164 = { class: "form-group d-flex flex-wrap" }
const _hoisted_165 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_166 = ["onClick"]
const _hoisted_167 = { class: "svg-icon svg-icon-3" }
const _hoisted_168 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_169 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_170 = { class: "indicator-label" }
const _hoisted_171 = { class: "card mb-5 mb-xl-10" }
const _hoisted_172 = { class: "card-header" }
const _hoisted_173 = { class: "card-title m-0" }
const _hoisted_174 = { class: "fw-boldest m-0" }
const _hoisted_175 = { class: "card-body p-9" }
const _hoisted_176 = { class: "form-group d-flex flex-wrap" }
const _hoisted_177 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_178 = { class: "row" }
const _hoisted_179 = { class: "col-md-6" }
const _hoisted_180 = { class: "form-group d-flex flex-wrap" }
const _hoisted_181 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_182 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_183 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_184 = { class: "indicator-label" }
const _hoisted_185 = { class: "card mb-5 mb-xl-10" }
const _hoisted_186 = { class: "card-header border-0" }
const _hoisted_187 = { class: "card-title m-0" }
const _hoisted_188 = { class: "fw-boldest m-0" }
const _hoisted_189 = { class: "card-body border-top p-9" }
const _hoisted_190 = { class: "row" }
const _hoisted_191 = { class: "col-md-6" }
const _hoisted_192 = { class: "form-group d-flex flex-wrap" }
const _hoisted_193 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_194 = { class: "el-form-item__content" }
const _hoisted_195 = { class: "col-md-6" }
const _hoisted_196 = { class: "form-group d-flex flex-wrap" }
const _hoisted_197 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_198 = { class: "el-form-item__content" }
const _hoisted_199 = { class: "col-md-6" }
const _hoisted_200 = { class: "form-group d-flex flex-wrap" }
const _hoisted_201 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_202 = { class: "el-form-item__content" }
const _hoisted_203 = { class: "col-md-6" }
const _hoisted_204 = { class: "form-group d-flex flex-wrap" }
const _hoisted_205 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_206 = { class: "el-form-item__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_AddKeyParametersModal = _resolveComponent("AddKeyParametersModal")!
  const _component_AddParentRelationshipModal = _resolveComponent("AddParentRelationshipModal")!
  const _component_AddRelatedRelationshipModal = _resolveComponent("AddRelatedRelationshipModal")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.leadsInfo.name), 1),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.leadsInfo.email)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: 'mailto:' + _ctx.leadsInfo.email,
                  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
                }, [
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com011.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.leadsInfo.email), 1)
                ], 8, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.leadsInfo.address)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen018.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.leadsInfo.address), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.leadsInfo.website)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  href: _ctx.leadsInfo.website,
                  class: "d-flex align-items-center text-gray-400 text-hover-primary mb-2",
                  target: "_blank"
                }, [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/coding/cod007.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.leadsInfo.website), 1)
                ], 8, _hoisted_9))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_el_form, {
      onSubmit: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      model: _ctx.formData,
      rules: _ctx.rules,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.$t("common.information")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("merchants.companyName")), 1),
                  _createVNode(_component_el_form_item, { prop: "name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_el_form_item, {
                    prop: "short_key",
                    class: "form-item-status"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: _ctx.formData.status,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.status) = $event)),
                        size: "mini"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_button, { label: "10" }, {
                            default: _withCtx(() => [
                              _hoisted_23
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio_button, { label: "15" }, {
                            default: _withCtx(() => [
                              _hoisted_24
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio_button, { label: "20" }, {
                            default: _withCtx(() => [
                              _hoisted_25
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("merchants.companyShortKey")), 1),
                  _createVNode(_component_el_form_item, { prop: "short_key" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.short_key,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.short_key) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("merchants.lastValidationDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "last_validation_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.last_validation_date,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.last_validation_date) = $event)),
                        type: "date",
                        clearable: "",
                        placeholder: _ctx.$t('common.plsPickDate'),
                        style: {"width":"100%"},
                        onChange: _cache[4] || (_cache[4] = ($event: any) => (
                    _ctx.commonChangeDefaultDate(
                      $event,
                      _ctx.formData,
                      'last_validation_date'
                    )
                  ))
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("merchants.lifecycleStatus")), 1),
                  _createVNode(_component_el_form_item, { prop: "lifecycle_status" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.lifecycle_status,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.lifecycle_status) = $event)),
                        clearable: "",
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Launched",
                            value: "10"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_37
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Trial",
                            value: "20"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_38
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("merchants.imprint")), 1),
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t("merchants.email")), 1),
                  _createVNode(_component_el_form_item, { prop: "email" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "email",
                        modelValue: _ctx.formData.email,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.email) = $event)),
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("merchants.website")), 1),
                  _createVNode(_component_el_form_item, { prop: "website" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.website,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.website) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.$t("merchants.telephone")), 1),
                  _createVNode(_component_el_form_item, { prop: "telephone" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.telephone,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.telephone) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t("merchants.telephone2")), 1),
                  _createVNode(_component_el_form_item, { prop: "telephone2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.telephone2,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.telephone2) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t("merchants.fax")), 1),
                  _createVNode(_component_el_form_item, { prop: "fax" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.fax,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.fax) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t("merchants.address")), 1),
                  _createVNode(_component_el_form_item, { prop: "address" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.address,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.address) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t("merchants.zipCode")), 1),
                  _createVNode(_component_el_form_item, { prop: "zip_code" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.zip_code,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.zip_code) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.$t("merchants.city")), 1),
                  _createVNode(_component_el_form_item, { prop: "city" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.city,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.city) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t("merchants.country")), 1),
                  _createVNode(_component_el_form_item, { prop: "country_iso_2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.country_iso_2,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.country_iso_2) = $event)),
                        clearable: "",
                        filterable: "",
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t("merchants.managingDirectors")), 1),
                  _createVNode(_component_el_form_item, { prop: "managing_directors" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.managing_directors,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.managing_directors) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.$t("merchants.utCommercialRegistry")), 1),
                  _createVNode(_component_el_form_item, { prop: "ut_commercial_registry" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.ut_commercial_registry,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.ut_commercial_registry) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.$t("merchants.leiRegister")), 1),
                  _createVNode(_component_el_form_item, { prop: "lei_register" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.lei_register,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.lei_register) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.$t("merchants.vatRegistrationNumber")), 1),
                  _createVNode(_component_el_form_item, { prop: "vat_registration_number" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.vat_registration_number,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.vat_registration_number) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_86, [
            _createVNode(_component_router_link, {
              to: "/merchant-network/leads",
              class: "btn btn-secondary align-self-center me-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("common.backToList")), 1)
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_87, [
              _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.$t("common.saveChanges")), 1)
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("h3", _hoisted_92, _toDisplayString(_ctx.$t("merchants.benchmark")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_93, [
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("div", _hoisted_96, [
                  _createElementVNode("label", _hoisted_97, _toDisplayString(_ctx.$t("merchants.yearOfIncorporation")), 1),
                  _createVNode(_component_el_form_item, { prop: "year_of_incorporation" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.year_of_incorporation,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.year_of_incorporation) = $event)),
                        "value-format": "YYYY",
                        type: "year",
                        placeholder: _ctx.$t('common.plsPickYear'),
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.$t("merchants.corporationType")), 1),
                  _createVNode(_component_el_form_item, { prop: "corporation_type" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.corporation_type,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.corporation_type) = $event)),
                        clearable: "",
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.corporationTypeOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_101, [
              _createElementVNode("div", _hoisted_102, [
                _createElementVNode("div", _hoisted_103, [
                  _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.$t("merchants.industry")), 1),
                  _createVNode(_component_el_form_item, { prop: "industry" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.industry,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.industry) = $event)),
                        multiple: "",
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.industryOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_105, [
              _createElementVNode("h3", _hoisted_106, _toDisplayString(_ctx.$t("merchants.keyParameters")), 1),
              _withDirectives((_openBlock(), _createElementBlock("button", {
                type: "button",
                class: "btn btn-sm btn-light-primary ms-6",
                "data-bs-toggle": "modal",
                "data-bs-target": "#modal_add_key_parameters",
                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.handleAddKeyParameters && _ctx.handleAddKeyParameters(...args))),
                circle: ""
              }, [
                _createElementVNode("span", _hoisted_107, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("merchants.addKeyParameters")), 1)
              ])), [
                [_directive_auth, { auth: ['update'] }]
              ])
            ]),
            _createElementVNode("div", _hoisted_108, [
              _createVNode(_component_el_table, {
                data: _ctx.keyParametersTableData,
                style: {"width":"100%"},
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('merchants.fiscalYear'),
                    prop: "fiscal_year",
                    align: "right"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('merchants.revenue'),
                    prop: "revenue",
                    align: "right"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('merchants.employees'),
                    prop: "employees",
                    align: "right"
                  }, null, 8, ["label"]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_table_column, {
                    label: "",
                    width: "100",
                    align: "right"
                  }, {
                    default: _withCtx(({ $index, row }) => [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#modal_add_key_parameters",
                        onClick: ($event: any) => (_ctx.handleEditKeyParameters($index, row))
                      }, [
                        _createElementVNode("span", _hoisted_110, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                        ])
                      ], 8, _hoisted_109),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                        onClick: ($event: any) => (_ctx.handleDeleteKeyParameters($index, row))
                      }, [
                        _createElementVNode("span", _hoisted_112, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                        ])
                      ], 8, _hoisted_111)
                    ]),
                    _: 1
                  })), [
                    [_directive_auth, { auth: ['update'] }]
                  ])
                ]),
                _: 1
              }, 8, ["data"])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_113, [
            _createVNode(_component_router_link, {
              to: "/merchant-network/leads",
              class: "btn btn-secondary align-self-center me-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("common.backToList")), 1)
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_114, [
              _createElementVNode("span", _hoisted_115, _toDisplayString(_ctx.$t("common.saveChanges")), 1)
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_116, [
          _createElementVNode("div", _hoisted_117, [
            _createElementVNode("div", _hoisted_118, [
              _createElementVNode("h3", _hoisted_119, _toDisplayString(_ctx.$t("merchants.organizationalStructure")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_120, [
            _createElementVNode("div", _hoisted_121, [
              _createElementVNode("h3", _hoisted_122, _toDisplayString(_ctx.$t("merchants.parentMerchant")), 1),
              _withDirectives((_openBlock(), _createElementBlock("button", {
                type: "button",
                class: "btn btn-sm btn-light-primary ms-6",
                "data-bs-toggle": "modal",
                "data-bs-target": "#modal_add_parent_relationship",
                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.handleAddParentRelationship && _ctx.handleAddParentRelationship(...args)))
              }, [
                _createElementVNode("span", _hoisted_123, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                ]),
                _hoisted_124
              ])), [
                [_directive_auth, { auth: ['update'] }]
              ])
            ]),
            _createElementVNode("div", _hoisted_125, [
              _createVNode(_component_el_table, {
                data: _ctx.parentRelationshipTableData,
                style: {"width":"100%"},
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('merchants.parentMerchant'),
                    prop: "related_merchant_id",
                    formatter: _ctx.getRelatedMerchantName
                  }, null, 8, ["label", "formatter"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('merchants.relationship'),
                    prop: "tag_value",
                    formatter: _ctx.getParentRelationshipLabel
                  }, null, 8, ["label", "formatter"]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_table_column, {
                    label: "",
                    width: "100",
                    align: "right"
                  }, {
                    default: _withCtx(({ $index, row }) => [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#modal_add_parent_relationship",
                        onClick: ($event: any) => (_ctx.handleEditParentRelationship($index, row))
                      }, [
                        _createElementVNode("span", _hoisted_127, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                        ])
                      ], 8, _hoisted_126),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                        onClick: ($event: any) => (_ctx.handleDeleteParentRelationship($index, row))
                      }, [
                        _createElementVNode("span", _hoisted_129, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                        ])
                      ], 8, _hoisted_128)
                    ]),
                    _: 1
                  })), [
                    [_directive_auth, { auth: ['update'] }]
                  ])
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _createElementVNode("div", _hoisted_130, [
              _createElementVNode("h3", _hoisted_131, _toDisplayString(_ctx.$t("merchants.relatedMerchant")), 1),
              _withDirectives((_openBlock(), _createElementBlock("button", {
                type: "button",
                class: "btn btn-sm btn-light-primary ms-6",
                "data-bs-toggle": "modal",
                "data-bs-target": "#modal_add_related_relationship",
                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.handleAddRelatedRelationship && _ctx.handleAddRelatedRelationship(...args)))
              }, [
                _createElementVNode("span", _hoisted_132, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                ]),
                _hoisted_133
              ])), [
                [_directive_auth, { auth: ['update'] }]
              ])
            ]),
            _createElementVNode("div", _hoisted_134, [
              _createVNode(_component_el_table, {
                data: _ctx.relatedRelationshipTableData,
                style: {"width":"100%"},
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('merchants.relatedMerchant'),
                    prop: "related_merchant_id",
                    formatter: _ctx.getRelatedMerchantName
                  }, null, 8, ["label", "formatter"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('merchants.relationship'),
                    prop: "tag_value",
                    formatter: _ctx.getRelatedRelationshipLabel
                  }, null, 8, ["label", "formatter"]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_table_column, {
                    label: "",
                    width: "100",
                    align: "right"
                  }, {
                    default: _withCtx(({ $index, row }) => [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#modal_add_related_relationship",
                        onClick: ($event: any) => (_ctx.handleEditRelatedRelationship($index, row))
                      }, [
                        _createElementVNode("span", _hoisted_136, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                        ])
                      ], 8, _hoisted_135),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                        onClick: ($event: any) => (_ctx.handleDeleteRelatedRelationship($index, row))
                      }, [
                        _createElementVNode("span", _hoisted_138, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                        ])
                      ], 8, _hoisted_137)
                    ]),
                    _: 1
                  })), [
                    [_directive_auth, { auth: ['update'] }]
                  ])
                ]),
                _: 1
              }, 8, ["data"])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_139, [
            _createVNode(_component_router_link, {
              to: "/merchant-network/leads",
              class: "btn btn-secondary align-self-center me-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("common.backToList")), 1)
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_140, [
              _createElementVNode("span", _hoisted_141, _toDisplayString(_ctx.$t("common.saveChanges")), 1)
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_142, [
          _createElementVNode("div", _hoisted_143, [
            _createElementVNode("div", _hoisted_144, [
              _createElementVNode("h3", _hoisted_145, _toDisplayString(_ctx.$t("merchants.corporationGroupTitle")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_146, [
            _createElementVNode("div", _hoisted_147, [
              _createElementVNode("div", _hoisted_148, [
                _createElementVNode("div", _hoisted_149, [
                  _createElementVNode("label", _hoisted_150, _toDisplayString(_ctx.$t("merchants.corporationGroup")), 1),
                  _createVNode(_component_el_form_item, { prop: "corporation_group_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.corporation_group_id,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.corporation_group_id) = $event)),
                        clearable: "",
                        filterable: "",
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_151, [
                _createElementVNode("div", _hoisted_152, [
                  _createElementVNode("label", _hoisted_153, _toDisplayString(_ctx.$t("merchants.positionInGroup")), 1),
                  _createVNode(_component_el_form_item, { prop: "position_in_group" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.position_in_group,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.position_in_group) = $event)),
                        clearable: "",
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positionInGroupOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_154, [
            _createVNode(_component_router_link, {
              to: "/merchant-network/leads",
              class: "btn btn-secondary align-self-center me-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("common.backToList")), 1)
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_155, [
              _createElementVNode("span", _hoisted_156, _toDisplayString(_ctx.$t("common.saveChanges")), 1)
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_157, [
          _createElementVNode("div", _hoisted_158, [
            _createElementVNode("div", _hoisted_159, [
              _createElementVNode("h3", _hoisted_160, _toDisplayString(_ctx.$t("merchants.salesChannels")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_161, [
            _createElementVNode("div", _hoisted_162, [
              _createElementVNode("div", _hoisted_163, [
                _createElementVNode("div", _hoisted_164, [
                  _createElementVNode("label", _hoisted_165, _toDisplayString(_ctx.$t("merchants.channelsMgmt")), 1),
                  _createVNode(_component_el_form_item, { prop: "channels_mgmt" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.channels_mgmt,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.channels_mgmt) = $event)),
                        clearable: "",
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelsMgmtOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createVNode(_component_el_table, {
              data: _ctx.salesChannelsTableData,
              style: {"width":"100%"},
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "Channel Name",
                  prop: "name"
                }),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('merchants.type'),
                  prop: "channel_type",
                  formatter: _ctx.getChannelTypeLabel
                }, null, 8, ["label", "formatter"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('merchants.country'),
                  prop: "country_iso_2",
                  formatter: _ctx.getCountryName
                }, null, 8, ["label", "formatter"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('merchants.city'),
                  prop: "city"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('merchants.email'),
                  prop: "email"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('merchants.telephone'),
                  prop: "telephone"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: "",
                  width: "100",
                  align: "right"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3",
                      onClick: ($event: any) => (_ctx.viewChanelDetail(row))
                    }, [
                      _createElementVNode("span", _hoisted_167, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                      ])
                    ], 8, _hoisted_166)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_168, [
            _createVNode(_component_router_link, {
              to: "/merchant-network/leads",
              class: "btn btn-secondary align-self-center me-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("common.backToList")), 1)
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_169, [
              _createElementVNode("span", _hoisted_170, _toDisplayString(_ctx.$t("common.saveChanges")), 1)
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_171, [
          _createElementVNode("div", _hoisted_172, [
            _createElementVNode("div", _hoisted_173, [
              _createElementVNode("h3", _hoisted_174, _toDisplayString(_ctx.$t("merchants.quickNotes")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_175, [
            _createElementVNode("div", _hoisted_176, [
              _createElementVNode("label", _hoisted_177, _toDisplayString(_ctx.$t("merchants.overallNotes")), 1),
              _createVNode(_component_el_form_item, { prop: "overall_notes" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.overall_notes,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.overall_notes) = $event)),
                    type: "textarea",
                    placeholder: _ctx.$t('common.plsEnter')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_178, [
              _createElementVNode("div", _hoisted_179, [
                _createElementVNode("div", _hoisted_180, [
                  _createElementVNode("label", _hoisted_181, _toDisplayString(_ctx.$t("merchants.interContact")), 1),
                  _createVNode(_component_el_form_item, { prop: "inter_contact" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.inter_contact,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.inter_contact) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_182, [
            _createVNode(_component_router_link, {
              to: "/merchant-network/leads",
              class: "btn btn-secondary align-self-center me-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("common.backToList")), 1)
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_183, [
              _createElementVNode("span", _hoisted_184, _toDisplayString(_ctx.$t("common.saveChanges")), 1)
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createElementVNode("div", _hoisted_185, [
      _createElementVNode("div", _hoisted_186, [
        _createElementVNode("div", _hoisted_187, [
          _createElementVNode("h3", _hoisted_188, _toDisplayString(_ctx.t("common.historyLog")), 1)
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_189, [
        _createElementVNode("div", _hoisted_190, [
          _createElementVNode("div", _hoisted_191, [
            _createElementVNode("div", _hoisted_192, [
              _createElementVNode("label", _hoisted_193, _toDisplayString(_ctx.t("common.creator")), 1),
              _createElementVNode("div", _hoisted_194, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.created_uid,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formData.__show.created_uid) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_195, [
            _createElementVNode("div", _hoisted_196, [
              _createElementVNode("label", _hoisted_197, _toDisplayString(_ctx.t("common.creationDate")), 1),
              _createElementVNode("div", _hoisted_198, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.created_at,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.formData.created_at) = $event)),
                  type: "datetime",
                  placeholder: "Pick a date",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_199, [
            _createElementVNode("div", _hoisted_200, [
              _createElementVNode("label", _hoisted_201, _toDisplayString(_ctx.t("common.lastModifiedBy")), 1),
              _createElementVNode("div", _hoisted_202, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.updated_uid,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formData.__show.updated_uid) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_203, [
            _createElementVNode("div", _hoisted_204, [
              _createElementVNode("label", _hoisted_205, _toDisplayString(_ctx.t("common.lastModifiedDate")), 1),
              _createElementVNode("div", _hoisted_206, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.updated_at,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formData.updated_at) = $event)),
                  type: "datetime",
                  placeholder: "Pick a date",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_AddKeyParametersModal, {
      id: _ctx.keyParametersId,
      "merchant-id": parseInt(_ctx.$route.params.id),
      onUpdateList: _ctx.updateKeyParametersList,
      onResetForm: _ctx.handleAddKeyParameters
    }, null, 8, ["id", "merchant-id", "onUpdateList", "onResetForm"]),
    _createVNode(_component_AddParentRelationshipModal, {
      id: _ctx.parentRelationshipId,
      "merchant-id": parseInt(_ctx.$route.params.id),
      onUpdateList: _ctx.updateParentRelationshipList,
      onResetForm: _ctx.handleAddParentRelationship
    }, null, 8, ["id", "merchant-id", "onUpdateList", "onResetForm"]),
    _createVNode(_component_AddRelatedRelationshipModal, {
      id: _ctx.relatedRelationshipId,
      "merchant-id": parseInt(_ctx.$route.params.id),
      onUpdateList: _ctx.updateRelatedRelationshipList,
      onResetForm: _ctx.handleAddRelatedRelationship
    }, null, 8, ["id", "merchant-id", "onUpdateList", "onResetForm"])
  ], 64))
}